export default __webpack_public_path__ + "e26d1b02265f2e4a4cec1304a79fbf24.webp";